<section class="perk-for-partner-wrapper">
  <div class="box-container">
    <!-- content -->
    <div class="box">
      <div class="box__left">
        <div class="title"
          ><span class="title-blue">{{ 'BECOME_OUR_PARTNER.PERK_FOR_PARTNER.HEADING_BLUE' | translate }}</span
          ><br /><span>{{ 'BECOME_OUR_PARTNER.PERK_FOR_PARTNER.HEADING_BLACK' | translate }}</span></div
        >

        <div class="perk-image">
          <ng-container *ngFor="let item of loopArray(4); let i = index">
            <picture *ngIf="currentSlide === i + 1">
              <source
                srcset="https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/benefit_section_image_{{ tab }}_v3.webp"
                type="image/webp"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/benefit_section_image_{{
                  tab
                }}_v3.jpg"
                width="100%"
                loading="lazy"
                [alt]="imageAlt"
                [title]="imageAlt"
                class="box__image"
              />
            </picture>
          </ng-container>
        </div>
      </div>

      <div class="box__right">
        <div class="tab__container"> </div>

        <div class="tab-list mobile"> </div>
        <div *ngIf="tab === PartnerPrivilegeEnum.PROMOTE" class="box__card">
          <ng-container *ngFor="let item of loopArray(6); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span [innerHtml]="'BECOME_OUR_PARTNER.PERK_FOR_PARTNER.PROMOTE.' + (i + 1) | translate"></span>
            </div>
          </ng-container>
        </div>

        <div *ngIf="tab === PartnerPrivilegeEnum.SPECIAL_TAKE_CARE" class="box__card">
          <ng-container *ngFor="let item of loopArray(4); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span [innerHtml]="'BECOME_OUR_PARTNER.PERK_FOR_PARTNER.SPECIAL_TAKE_CARE.' + (i + 1) | translate"></span>
            </div>
          </ng-container>
        </div>

        <div *ngIf="tab === PartnerPrivilegeEnum.BE_PART_OF_TEAM" class="box__card">
          <ng-container *ngFor="let item of loopArray(5); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span [innerHtml]="'BECOME_OUR_PARTNER.PERK_FOR_PARTNER.BE_PART_OF_TEAM.' + (i + 1) | translate"></span>
            </div>
          </ng-container>
        </div>

        <div *ngIf="tab === PartnerPrivilegeEnum.SPECIAL_PRIZE" class="box__card">
          <ng-container *ngFor="let item of loopArray(5); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span [innerHtml]="'BECOME_OUR_PARTNER.PERK_FOR_PARTNER.SPECIAL_PRIZE.' + (i + 1) | translate"></span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>
